<template>
  <div class="embed-layout">
    <iframe
      v-if="valid"
      name="iframe"
      :src="contentData.url"
      frameborder="0"
      ref="iframeDom"
      loading="lazy"
      allowtransparency="true"
      :key="iframeKey"
      scrolling="no"
      style="width: 100%; height: 100%; position: absolute; opacity: 0.2; pointer-events: none"
    ></iframe>
    <!-- <v-row align="center" justify="center" dense no-gutters>
      <v-col class="pl-10 pr-10">
        <span id="embed">Embed</span>
      </v-col>
    </v-row> -->
    <!-- 캘린들리 url -->
    <v-row align="center" justify="center" dense no-gutters style="width: 100%">
      <v-col class="px-10" align="center">
        <div class="input-div">
          <v-text-field
            label="Embed Link (Calendly, CodePen, etc.)"
            dark
            :class="valid ? 'embedUrl validUrl' : 'embedUrl'"
            placeholder="Paste in https://..."
            type="input"
            v-model="contentData.url"
            solo
            background-color="#1a272e"
            :rules="[rules.required, rules.url]"
            flat
          ></v-text-field>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row align="center" justify="center">
      <v-col class="mt-0 pl-10 pr-10 pb-0">
        <v-text-field
          label="Enter title (optional)"
          :placeholder="$t('enterTitle')"
          v-model="clipTitle"
          dark
          solo
          background-color="#1a272e"
          hide-details
          flat
        ></v-text-field>
      </v-col>
    </v-row> -->

    <!-- <v-row align="center" justify="center" class="px-7">
      <v-col align="start" class="mb-7" style="color: #eee; font-weight: 700">
        {{ 'Notification' }}
      </v-col>
      <v-col align="end" class="mb-7">
        <notification-dialog
          @customRecipientList="customRecipientList"
          @chkboxWs="chkboxWs"
          @chkboxPostComment="chkboxPostComment"
        ></notification-dialog>
      </v-col>
    </v-row> -->

    <!-- <v-row no-gutters class="px-7 pb-8" justify="center" align="center">
      <v-col class="row-thumbnail" align="center" no-gutters>
        <v-btn block color="#96a7af" width="100" @click="$emit('discardPreview')">
          {{ $t('discard') }}
        </v-btn>
      </v-col>
      <v-col class="row-thumbnail ml-4" align="center" no-gutters>
        <v-btn
          color="#27cd8b"
          width="100"
          block
          :loading="isEmbedUploadLoading"
          :disabled="contentData.url === null || contentData.url === '' || this.valid === false"
          @click="embed"
        >
          {{ $t('post') }}
        </v-btn>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
// import Toast from '@/views/meeting/component/Toast'
// import NotificationDialog from '@/views/modal/NotificationDialog'

export default {
  name: 'embedDialog',
  components: {
    // NotificationDialog,
  },
  props: {
    recordType: String,
    blob: {
      type: null,
      required: true,
    },
    duration: Number,
  },
  mounted() {
    if (this.blob && this.blob !== null) {
      this.blobUrl = URL.createObjectURL(this.blob)
    }
  },
  data() {
    return {
      clipTitle: '',
      note: '',
      poster: '',
      iframeKey: 0,
      blobUrl: null,
      blobData: null,
      isEmbedUploadLoading: false,
      contentData: {
        clipType: 'embed',
        type: 'default',
        url: '',
      },
      rules: {
        required: (value) => !!value || 'Required.',
        embed: (value) => {
          const pattern = /^http[s]?:\/\/embed.com\/([\S]{1,})\/([\S]{1,})/g
          if (value.length > 0) {
            if (pattern.test(value)) {
              return (this.valid = true)
            } else {
              this.valid = false
              return 'Please check the URL you entered'
            }
          } else {
            this.valid = false
            return true
          }
        },
        url: (value) => {
          const pattern = /(http[s]?|ftp):\/\/(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}/g
          if (value.length > 0) {
            if (pattern.test(value)) {
              return (this.valid = true)
            } else {
              this.valid = false
              return 'Please check the URL you entered'
            }
          } else {
            this.valid = false
            return true
          }
        },
      },
      valid: true,
    }
  },
  beforeDestroy() {
    if (this.blobUrl !== null) {
      URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = null
    }
  },
  methods: {
    customRecipientList(val) {
      this.$emit('customRecipientList', val)
    },
    chkboxPostComment(val) {
      this.$emit('chkboxPostComment', val)
    },
    chkboxWs(val) {
      this.$emit('chkboxWs', val)
    },
    embed() {
      if (this.contentData.url.indexOf('calendly.com') > -1) {
        this.contentData.type = 'calendar'
      } else {
        this.contentData.type = 'default'
      }
      this.isEmbedUploadLoading = true
      this.$emit('templateUpload', this.contentData)
    },
  },
  computed: {
    mtInfo() {
      return this.$store.getters.currentMt
    },
  },
  watch: {
    note() {
      this.$emit('clipNote', this.note)
    },
    clipTitle(val) {
      this.$emit('clipTitle', val)
    },
    contentData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$emit('contentData', val)
      },
    },
    valid(val) {
      this.$emit('valid', val)
    },
  },
}
</script>

<style scoped>
.embed-layout {
  display: flex;
  position: relative;
  min-width: 360px;
  width: 100%;
  height: 100%;
  /* max-width: 500px; */
  /* background-color: #21343b; */
  /* border-radius: 10px; */
  flex-direction: column;
  align-items: center;
}
span {
  color: white;
  font-weight: bold;
}
#embed {
  font-size: 20px;
}
#note {
  font-size: 14px;
}
#text-length {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: right;
  transform: translate(-20px, -30px);
  font-weight: normal;
  color: #869399;
}
.share-text-div {
  background: #1a272e;
  width: 100%;
  height: 200px;
  display: inline-block;
  vertical-align: middle;
}
.el-textarea >>> .el-textarea__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.embedUrl >>> .el-textarea__inner {
  background: #1a272e;
  text-align: center !important;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  resize: none;
}
.el-input >>> .el-input__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.input-div {
  width: 100%;
  display: inline-block;
  vertical-align: middle;
}

.row-thumbnail >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: white;
  font-weight: bold;
}
.embedUrl {
  width: 100%;
  max-width: 800px;
}
.validUrl >>> .v-input__slot {
  border: 1px solid rgb(40, 144, 103) !important;
  box-shadow: 0px 0px 10px #00000020;
}
</style>
